import getDisplayName from "./utils/getDisplayName";
export function wrapDisplayName(name) {
    return {
        staticCallback: function (componentClass, target) {
            componentClass["displayName"] = name + "(" + getDisplayName(target) + ")";
        },
    };
}
export default wrapDisplayName;

//# sourceMappingURL=wrapDisplayName.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/wrapDisplayName.js
// module id = 76
// module chunks = 0